"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Icons = _interopRequireDefault(require("../baseComponents/Icons"));
var _TextField = _interopRequireDefault(require("../baseComponents/TextField"));
var _classnames = _interopRequireDefault(require("classnames"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var state = {
  search: ""
};
var SearchInput = /*#__PURE__*/function (_Component) {
  function SearchInput(props) {
    var _this;
    _classCallCheck(this, SearchInput);
    _this = _callSuper(this, SearchInput, [props]);
    _defineProperty(_this, "resetInputFieldWidth", function () {
      if (_this.props.clearable && _this.props.autoResize) {
        if (_this.props.placeholder) _this.setState({
          width: "calc(".concat(_this.calculateInputWidth(_this.props.placeholder), " + 1ch)")
        }); // gives enough space for text to finish})
        else _this.setState({
          width: "100%"
        });
      }
    });
    _defineProperty(_this, "addEventListenerToEsc", function (e) {
      if (e.keyCode == 27) {
        _this.clearSearchInput();
        _this.resetInputFieldWidth();
      }
    });
    _this.state = {
      search: props.search ? props.search : ""
    };
    _this.typingTimer = null;
    _this.handleField = _this.handleField.bind(_this);
    _this.clearSearchInput = _this.clearSearchInput.bind(_this);
    return _this;
  }
  _inherits(SearchInput, _Component);
  return _createClass(SearchInput, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('keydown', this.addEventListenerToEsc);
      // Remember state for the next mount
      // Re: remembering the state is causing a problem that the seach field is preserving the search text navigating
      // between different places that has a search input, so I am commenting it now to keep track if a problem happened
      // then we might consider making this will a flag prop or something otherwise it could be removed
      // state = this.state
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('keydown', this.addEventListenerToEsc);
      this.resetInputFieldWidth();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState, snapshot) {
      if (prevProps.placeholder !== this.props.placeholder) {
        this.resetInputFieldWidth();
      }
    }
  }, {
    key: "handleField",
    value: function handleField(e) {
      e.preventDefault();
      var val = e.target.value;
      state.search = val;
      if (this.props.inputCleanupPattern) {
        val = val.replace(RegExp(this.props.inputCleanupPattern, "g"), "");
      }
      this.setState({
        search: val
      });
      this.searchTypingTimer(val);
    }
  }, {
    key: "searchTypingTimer",
    value: function searchTypingTimer(search) {
      var _this2 = this;
      clearTimeout(this.typingTimer);
      this.typingTimer = setTimeout(function () {
        if (_this2.props.onChange) {
          _this2.props.onChange(search);
        }
      }, this.props.intervalTime);
    }
  }, {
    key: "clearSearchInput",
    value: function clearSearchInput() {
      this.handleField({
        preventDefault: function preventDefault() {},
        target: {
          value: ""
        }
      });
      this.resetInputFieldWidth();
    }
  }, {
    key: "calculateInputWidth",
    value: function calculateInputWidth(value, addedChar) {
      var text = document.createElement("span");
      document.body.appendChild(text);
      text.style.height = 'auto !important';
      text.style.width = 'auto !important';
      text.style.position = 'absolute';
      text.style.whiteSpace = 'pre-wrap';
      text.innerHTML = value + addedChar;
      var width = Math.ceil(text.clientWidth);
      var formattedWidth = width + 'px';
      document.body.removeChild(text);
      return formattedWidth;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var value = this.props.controlled ? this.props.search : this.state.search;
      var classes = (0, _classnames["default"])("searchInput-component", this.props.className, this.props.fieldStyle, {
        "expendable": this.props.expendable,
        "filled": value,
        "clearable": this.props.clearable
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: classes,
        style: this.props.style
      }, this.props.preSearchObj && /*#__PURE__*/_react["default"].createElement("div", {
        className: "preSearch"
      }, this.props.preSearchObj), /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        className: "search-icon",
        name: "glyph-search",
        onClick: function onClick(e) {
          e.currentTarget.nextElementSibling.querySelector("input").focus();
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "searchInput-textContainer"
      }, /*#__PURE__*/_react["default"].createElement(_TextField["default"], {
        customValue: this.props.customValue,
        width: this.state.width,
        name: "contentSearch",
        value: value,
        placeholder: this.props.placeholder,
        onChange: this.handleField,
        autoComplete: "off",
        onKeyDown: function onKeyDown(e) {
          if (e.keyCode == 13) {
            e.target.blur();
            if (e.target.value.length <= 1) {
              _this3.resetInputFieldWidth();
              return;
            }
          }
          if (e.keyCode == 27) {
            e.target.blur();
            _this3.clearSearchInput();
            _this3.resetInputFieldWidth();
            return;
          }
          var c = String.fromCharCode(e.keyCode | e.charCode);
          // that makes the value for the smalled letter 'i' and
          //largest letter 'W' looks good
          if (e.keyCode == 8 && e.target.value.length <= 1) {
            _this3.resetInputFieldWidth();
            return;
          }
          if (_this3.props.clearable && _this3.props.autoResize) {
            _this3.setState({
              width: "calc(".concat(_this3.calculateInputWidth(e.target.value, c), " + 1ch)") // gives enough space for text to finish
            });
          }
        }
      }), this.props.clearable && /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])("clear-icon", {
          "hide": !value
        }),
        onClick: function onClick(e) {
          _this3.clearSearchInput();
          e.currentTarget.previousElementSibling.querySelector("input").focus();
        }
      }, /*#__PURE__*/_react["default"].createElement(_Icons["default"], {
        name: "glyph-remove",
        isAction: true
      }), /*#__PURE__*/_react["default"].createElement("div", null, this.props.clearText))), this.props.postSearchObj && /*#__PURE__*/_react["default"].createElement("div", {
        className: "postSearch"
      }, this.props.postSearchObj));
    }
  }]);
}(_react.Component);
SearchInput.Proptypes = {
  preSearchObj: _propTypes["default"].object,
  postSearchObj: _propTypes["default"].object,
  search: _propTypes["default"].string,
  expendable: _propTypes["default"].bool,
  placeholder: _propTypes["default"].string,
  onChange: _propTypes["default"].func,
  intervalTime: _propTypes["default"].number,
  className: _propTypes["default"].string,
  style: _propTypes["default"].object,
  clearable: _propTypes["default"].bool,
  clearText: _propTypes["default"].string,
  fieldStyle: _propTypes["default"].oneOf(["boxed", "minimalist"]),
  customValue: _propTypes["default"].object,
  autoResize: _propTypes["default"].bool,
  inputCleanupPattern: _propTypes["default"].string
};
SearchInput.defaultProps = {
  fieldStyle: "minimalist",
  search: "",
  expendable: false,
  placeholder: "",
  onChange: function onChange() {},
  intervalTime: 800,
  className: "",
  style: {},
  clearable: false,
  clearText: '(esc to clear)',
  customValue: null,
  autoResize: true,
  inputCleanupPattern: null
};
var _default = exports["default"] = SearchInput;